const rollBitsLink = 'https://roll-bits.com/';

export default rollBitsLink;
